<template>
  <div>
    <vue-headful title="Verander wachtwoord" />
    <Header page_title="Verander wachtwoord" />
    <div class="pt-4 min-height">
      <div class="container-fluid px-4 mx-2">
        <form class="sd-form" @submit.prevent="onSubmit">
          <NotificationContainer />
          <div class="form-group w-square-icon mb-4 sd-input">
            <label>Huidig wachtwoord <span class="required">*</span></label>
            <input
              v-model="form.current_password"
              v-bind:type="[!pass ? 'text' : 'password']"
              class="form-control"
              placeholder="Huidig wachtwoord"
              autocomplete="nope"
              required
            />
            <div
              class="icon-wrapper eye position-absolute align-self-center"
              v-on:click="pass = false"
              v-if="pass"
            >
              <span><svg-icon icon="eye" /></span>
            </div>
            <div
              class="icon-wrapper eye shown position-absolute align-self-center"
              v-on:click="pass = true"
              v-else
            >
              <svg-icon icon="eye_hidden" />
            </div>
          </div>
          <hr class="mb-4" />
          <div class="input-row">
            <div class="form-group w-square-icon sd-input sd-col-6">
              <label>Nieuw wachtwoord <span class="required">*</span></label>
              <input
                v-model="form.password"
                v-bind:type="[!pass1 ? 'text' : 'password']"
                class="form-control"
                placeholder="Nieuw wachtwoord"
                autocomplete="nope"
                required
              />
              <div
                class="icon-wrapper eye position-absolute align-self-center"
                v-on:click="pass1 = false"
                v-if="pass1"
              >
                <span><svg-icon icon="eye" /></span>
              </div>
              <div
                class="icon-wrapper eye shown position-absolute align-self-center"
                v-on:click="pass1 = true"
                v-else
              >
                <svg-icon icon="eye_hidden" />
              </div>
            </div>
            <div class="form-group w-square-icon mb-4 sd-input sd-col-6">
              <label>Bevestig nieuw wachtwoord <span class="required">*</span></label>
              <input
                v-model="form.password_confirmation"
                v-bind:type="[!pass2 ? 'text' : 'password']"
                class="form-control"
                placeholder="Bevestig nieuw wachtwoord"
                autocomplete="nope"
                required
              />

              <div
                class="icon-wrapper eye position-absolute align-self-center"
                v-on:click="pass2 = false"
                v-if="pass2"
                v-ripple="'rgba(255, 255, 255, 0.35)'"
              >
                <span><svg-icon icon="eye" /></span>
              </div>
              <div
                class="icon-wrapper eye shown position-absolute align-self-center"
                v-on:click="pass2 = true"
                v-else
                v-ripple="'rgba(255, 255, 255, 0.35)'"
              >
                <svg-icon icon="eye_hidden" />
              </div>
            </div>
          </div>
          <button
            type="submit"
            class="btn btn-warning btn-block"
            v-ripple="'rgba(255, 255, 255, 0.35)'"
          >
            Vernieuw wachtwoord
          </button>
        </form>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      form: {
        current_password: "",
        password: "",
        password_confirmation: ""
      },
      pass: true,
      pass1: true,
      pass2: true
    };
  },
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    async fetchData() {},
    async onSubmit() {
      this.$store.state.loading = true;
      await this.updatePassword();
      await this.updateLogin();
      this.$store.state.loading = false;
    },
    async updatePassword() {
      return new Promise((resolve, reject) => {
        let formData = new FormData();
        for (var obj in this.form) {
          formData.append(obj, this.form[obj]);
        }
        var user_token = JSON.parse(localStorage.getItem("user-token"));
        var url = this.$apiURI + "/auth/password";
        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(() => {
            // console.log(success);
            const notification = {
              type: "success",
              message: "Je hebt je gegevens succesvol aangepast. "
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            resolve();
          })
          .catch(() => {
            // console.log(error);
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden.",
                error: true
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            this.$store.state.loading = false;
            reject();
          });
      });
    },
    async updateLogin() {
      return new Promise(resolve => {
        // reset form
        this.form = {
          current_password: "",
          password: "",
          password_confirmation: ""
        };
        this.pass = this.pass1 = this.pass2 = true;
        this.$store.state.loading = false;
        resolve();
      });
    }
  }
};
</script>

<style scoped></style>
